import { VoucherOcr } from "~/application/types";
import { DateFormats, displayDate } from "~/utils/date.utils";
import { VoucherOcrDTO } from "../dtos";
import { mapForbiddenExpenseItemDTO } from "./mapForbiddenExpenseItemDTO";

export function mapVoucherOcrDTO({ voucher_ocr, message }: VoucherOcrDTO): VoucherOcr {
  return {
    code: voucher_ocr?.code,
    date: voucher_ocr?.date ? displayDate(voucher_ocr.date, DateFormats.ISO_DATE) : null,
    value: voucher_ocr?.value ? Number(voucher_ocr.value) : null,
    establishmentName: voucher_ocr?.establishment_name,
    establishmentAddress: voucher_ocr?.establishment_address,
    establishmentAddressCountry: voucher_ocr?.establishment_address_country,
    establishmentAddressState: voucher_ocr?.establishment_address_state,
    establishmentAddressCity: voucher_ocr?.establishment_address_city,
    establishmentAddressDistrict: voucher_ocr?.establishment_address_district,
    expenseCategoryName: voucher_ocr?.expense_category_name,
    expenseCategoryId: voucher_ocr?.expense_category_uuid,
    expenseTypeName: voucher_ocr?.expense_type_name,
    expenseTypeId: voucher_ocr?.expense_type_uuid,
    forbiddenExpenseItems: voucher_ocr?.forbidden_expense_items
      ? voucher_ocr.forbidden_expense_items.map((forbiddenExpenseItem) => ({
          ...mapForbiddenExpenseItemDTO(forbiddenExpenseItem),
          suspectedItems: forbiddenExpenseItem.suspected_items.map((suspectedItem) => ({
            word: suspectedItem.word,
            reason: suspectedItem.reason,
            items: suspectedItem.items,
          })),
        }))
      : [],
    message,
  };
}
